import React from 'react';
import './Pages.css';

const Customers = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Customers</h1>
        <p>Manage customer information</p>
      </div>
      <div className="page-content">
        <p>Customers content goes here...</p>
      </div>
    </div>
  );
};

export default Customers;